import type { MapLayerSpecification } from './map_layer_specification';

const lineLayout = {
  'line-join': 'round' as const,
  'line-cap': 'round' as const
};

interface PathPaint {
  remainingOpacity?: number;
  lineWidth: number;
  remainingDash?: [number, number];
}

export function journeyPathLayers({
  remainingOpacity = 0.75,
  lineWidth,
  remainingDash
}: PathPaint): MapLayerSpecification[] {
  const remainingPaint: Record<string, unknown> = {
    'line-color': '#F88300',
    'line-opacity': remainingOpacity,
    'line-width': lineWidth
  };

  if (remainingDash) {
    remainingPaint['line-dasharray'] = remainingDash;
  }

  return [
    {
      id: 'remaining-path',
      source: 'map-data',
      type: 'line',
      filter: ['==', ['get', 'variant'], 'remaining-path'],
      layout: lineLayout,
      paint: remainingPaint
    },
    {
      id: 'completed-path',
      source: 'map-data',
      type: 'line',
      filter: ['==', ['get', 'variant'], 'completed-path'],
      layout: lineLayout,
      paint: {
        'line-color': '#F88300',
        'line-width': lineWidth
      }
    },
    {
      id: 'current-location',
      source: 'map-data',
      filter: ['==', ['get', 'variant'], 'current-location'],
      type: 'symbol',
      layout: {
        'icon-image': 'pulsing-dot'
      }
    },
    {
      id: 'progress-updates',
      source: 'map-data',
      type: 'circle',
      filter: ['==', ['get', 'variant'], 'progress-update'],
      paint: {
        'circle-color': 'transparent',
        'circle-radius': 4,
        'circle-stroke-width': 2,
        'circle-stroke-color': '#ffffff'
      }
    },
    {
      id: 'route-path',
      source: 'map-data',
      type: 'line',
      filter: ['==', ['get', 'variant'], 'route-path'],
      layout: lineLayout,
      paint: {
        'line-color': '#F88300',
        'line-width': lineWidth
      }
    }
  ];
}
